module.exports = __webpack_public_path__ + "img/book-btn02.bdb9138c.png";